import React, { createContext, useState, useContext, useEffect } from 'react';

const FortuneContext = createContext();

export const useFortuneData = () => useContext(FortuneContext);

export const FortuneProvider = ({ children }) => {
  // User birth information
  const [userBirthInfo, setUserBirthInfo] = useState({
    year: '',
    month: '',
    day: '',
    hour: '',
    minute: '',
    unknownTime: false
  });

  // Partner birth information (for compatibility readings)
  const [partnerBirthInfo, setPartnerBirthInfo] = useState({
    year: '',
    month: '',
    day: '',
    hour: '',
    minute: '',
    unknownTime: false
  });

  // User's concern or question
  const [userConcern, setUserConcern] = useState('');

  // Selected product
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Fortune reading result
  const [fortuneResult, setFortuneResult] = useState(null);

  // Load saved data from localStorage on mount
  useEffect(() => {
    const savedUserBirthInfo = localStorage.getItem('userBirthInfo');
    const savedPartnerBirthInfo = localStorage.getItem('partnerBirthInfo');
    const savedUserConcern = localStorage.getItem('userConcern');
    const savedSelectedProduct = localStorage.getItem('selectedProduct');
    
    if (savedUserBirthInfo) setUserBirthInfo(JSON.parse(savedUserBirthInfo));
    if (savedPartnerBirthInfo) setPartnerBirthInfo(JSON.parse(savedPartnerBirthInfo));
    if (savedUserConcern) setUserConcern(savedUserConcern);
    if (savedSelectedProduct) setSelectedProduct(JSON.parse(savedSelectedProduct));
  }, []);

  // Save data to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('userBirthInfo', JSON.stringify(userBirthInfo));
  }, [userBirthInfo]);

  useEffect(() => {
    localStorage.setItem('partnerBirthInfo', JSON.stringify(partnerBirthInfo));
  }, [partnerBirthInfo]);

  useEffect(() => {
    localStorage.setItem('userConcern', userConcern);
  }, [userConcern]);

  useEffect(() => {
    if (selectedProduct) {
      localStorage.setItem('selectedProduct', JSON.stringify(selectedProduct));
    }
  }, [selectedProduct]);

  // Clear all fortune data
  const clearFortuneData = () => {
    setUserBirthInfo({
      year: '',
      month: '',
      day: '',
      hour: '',
      minute: '',
      unknownTime: false
    });
    setPartnerBirthInfo({
      year: '',
      month: '',
      day: '',
      hour: '',
      minute: '',
      unknownTime: false
    });
    setUserConcern('');
    setSelectedProduct(null);
    setFortuneResult(null);
    
    localStorage.removeItem('userBirthInfo');
    localStorage.removeItem('partnerBirthInfo');
    localStorage.removeItem('userConcern');
    localStorage.removeItem('selectedProduct');
    localStorage.removeItem('fortuneResult');
  };

  // Save fortune reading history
  const saveFortuneHistory = (result) => {
    const history = JSON.parse(localStorage.getItem('fortuneHistory') || '[]');
    const newHistoryItem = {
      id: Date.now().toString(),
      date: new Date().toISOString(),
      product: selectedProduct,
      userBirthInfo,
      partnerBirthInfo: selectedProduct?.requiresPartner ? partnerBirthInfo : null,
      userConcern,
      result
    };
    
    history.unshift(newHistoryItem);
    localStorage.setItem('fortuneHistory', JSON.stringify(history));
    
    return newHistoryItem;
  };

  // Get fortune reading history
  const getFortuneHistory = () => {
    return JSON.parse(localStorage.getItem('fortuneHistory') || '[]');
  };

  const value = {
    userBirthInfo,
    setUserBirthInfo,
    partnerBirthInfo,
    setPartnerBirthInfo,
    userConcern,
    setUserConcern,
    selectedProduct,
    setSelectedProduct,
    fortuneResult,
    setFortuneResult,
    clearFortuneData,
    saveFortuneHistory,
    getFortuneHistory
  };

  return (
    <FortuneContext.Provider value={value}>
      {children}
    </FortuneContext.Provider>
  );
};

export default FortuneContext;
